import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Download, Users, DollarSign, FileText, TrendingUp, Car, BarChart3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import Expenses from './Expenses';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Finances = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('revenue');
  const [stats, setStats] = useState({
    total_clients: 0,
    monthly_revenue: 0,
    invoice_revenue: 0,
    total_revenue: 0,
    vehicle_count: 0,
    avg_revenue_per_client: 0
  });
  const [invoiceLink, setInvoiceLink] = useState('');

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await axios.get(`${API}/stats/finances`);
      setStats(res.data);
    } catch (error) {
      console.error('Failed to fetch finance stats:', error);
    }
  };

  const handleExportCSV = async () => {
    try {
      const response = await axios.get(`${API}/finances/export-csv`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'finances.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('CSV файлът бе изтеглен!');
    } catch (error) {
      toast.error('Грешка при изтегляне на CSV');
    }
  };

  const statCards = [
    { icon: Users, label: 'Общо клиенти', value: stats.total_clients, color: '#3b82f6' },
    { icon: DollarSign, label: 'Месечен приход', value: `${stats.monthly_revenue.toFixed(2)} лв`, color: '#10b981' },
    { icon: FileText, label: 'Приходи от фактури', value: `${stats.invoice_revenue.toFixed(2)} лв`, color: '#8b5cf6' },
    { icon: TrendingUp, label: 'Общ приход', value: `${stats.total_revenue.toFixed(2)} лв`, color: '#f59e0b' },
    { icon: Car, label: 'Брой автомобили', value: stats.vehicle_count, color: '#06b6d4' },
    { icon: BarChart3, label: 'Среден приход на клиент', value: `${stats.avg_revenue_per_client.toFixed(2)} лв`, color: '#ec4899' }
  ];

  return (
    <div className="page-container" data-testid="finances-page">
      <div className="page-header">
        <h1 className="page-title">{t('finances')}</h1>
        <Button onClick={handleExportCSV} data-testid="export-csv-btn">
          <Download size={20} /> Експорт CSV
        </Button>
      </div>

      {/* Tabs */}
      <div className="finances-tabs">
        <button
          className={`finance-tab ${activeTab === 'revenue' ? 'active' : ''}`}
          onClick={() => setActiveTab('revenue')}
          data-testid="tab-revenue"
        >
          Приходи
        </button>
        <button
          className={`finance-tab ${activeTab === 'expenses' ? 'active' : ''}`}
          onClick={() => setActiveTab('expenses')}
          data-testid="tab-expenses"
        >
          Разходи
        </button>
      </div>

      {activeTab === 'revenue' && (
        <div>

      <div className="finances-stats-grid">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="finance-stat-card" data-testid={`finance-stat-${index}`}>
              <div className="stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                <Icon size={32} />
              </div>
              <div className="stat-content">
                <div className="stat-label">{stat.label}</div>
                <div className="stat-value">{stat.value}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="invoice-link-section">
        <h3>Google Drive линк за фактури</h3>
        <div className="invoice-link-input">
          <Input
            placeholder="Въведете Google Drive линк"
            value={invoiceLink}
            onChange={(e) => setInvoiceLink(e.target.value)}
            data-testid="invoice-link-input"
          />
          <Button onClick={() => toast.success('Линкът бе запазен!')} data-testid="save-invoice-link-btn">
            Запази
          </Button>
        </div>
      </div>
        </div>
      )}

      {activeTab === 'expenses' && <Expenses />}
    </div>
  );
};

export default Finances;
